import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import axios from 'axios';
// import { Cookies } from '../../../index.js';
// import { alert_error, alert_success } from "../../../AppContext.js";
import { useParams, useNavigate, Link } from 'react-router-dom';
import Orders_main from './orders_main';
import Orders from '../../../../order/orders/orders.jsx';

const Account_home = () => {
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    const { slug_1, slug_2, slug_3 } = useParams();
    return (
        <>
            {
                slug_2 && (
                    <>
                        {slug_2 === 'play' && (
                            (/^\d+$/.test(String(slug_3).split('_').pop() || '')
                                && (String(slug_3).split('_').pop() || '').length >= 3)
                                ? <Orders_main />
                                : <Orders servicecode="accounts" />
                        )}
                        {slug_2 === 'search' && (
                            (/^\d+$/.test(String(slug_3).split('_').pop() || '')
                                && (String(slug_3).split('_').pop() || '').length >= 3)
                                ? <Orders_main />
                                : <Orders category_main="accounts_search" />
                        )}
                    </>
                )
            }
        </>
    );
};

export default Account_home;
